import type * as React from "react";

import { ReactButton } from "../Button/Button";
import { ReactIconButton } from "../ReactIconButton/ReactIconButton";

export const TrackButton: React.FC<any> = (props) => {
    const settedProps = {
        ...props,
        iconName: "checked",
    };

    return props.isTracked ? <ReactIconButton {...settedProps} /> : <ReactButton {...props} />;
};

